import { apiFetch } from "./auth";
import { pickField } from "./fieldHelpers";

// Contact role codes come from Epicor's RoleCd table — the same list Epicor
// validates CustCnt.RoleCode against. Hardcoding them caused "A valid Role is
// required" for codes that don't exist in this company. Fetched once and cached
// for the session; falls back to the legacy list if the call fails.
const API_URL = process.env.REACT_APP_API_URL;

export const ROLE_FALLBACK = ["Purch", "OR", "AP", "SUPPLY", "OWNER"];

const f = (o, k, d = "") => { const v = pickField(o, k); return v === undefined || v === null ? d : v; };

let cache = null;

export async function fetchRoleCodes() {
  if (cache) return cache;
  try {
    const r = await apiFetch(`${API_URL}/api/RoleCd`);
    const data = await r.json().catch(() => null);
    const list = (data && (data.roleCds || data.RoleCds)) || [];
    const codes = list
      .filter((rc) => !f(rc, "Inactive", false))
      .map((rc) => f(rc, "RoleCode"))
      .filter(Boolean);
    if (codes.length) { cache = codes; return codes; }
  } catch { /* fall through to the fallback list */ }
  return ROLE_FALLBACK;
}
